export const convertCabinGradeName = (t: any, type: string) => {
	return {
		E: t('home.jingjicang'),
		S: t('home.gaojijingjicang'),
		F: t('home.toudengcang'),
		B: t('home.shangwucang'),
	}[type];
};
export const cabinGradeList = (t: any) => {
	return [{
		label: t('home.jingjicang'),
		value: 'E',
		icon: 'tt-economy'
	}, {
		label: t('home.gaojijingjicang'),
		value: 'S',
		icon: 'tt-premium'
	}, {
		label: t('home.toudengcang'),
		value: 'F',
		icon: 'tt-firstclass'
	}, {
		label: t('home.shangwucang'),
		value: 'B',
		icon: 'tt-business'
	}];
};
